import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from "react";
import { isImageSlide, makeUseContext, useEventCallback, useLayoutEffect, useLightboxState } from "../../core/index.js";
var ZoomContext = React.createContext(null);
export var useZoom = makeUseContext("useZoom", "ZoomContext", ZoomContext);
export var ZoomContextProvider = function ZoomContextProvider(_ref) {
  var slides = _ref.slides,
      children = _ref.children;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isMinZoom = _React$useState2[0],
      setIsMinZoom = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isMaxZoom = _React$useState4[0],
      setIsMaxZoom = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isZoomSupported = _React$useState6[0],
      setIsZoomSupported = _React$useState6[1];

  var _useLightboxState = useLightboxState(),
      currentIndex = _useLightboxState.state.currentIndex;

  var updateZoomSupported = useEventCallback(function () {
    return setIsZoomSupported(slides.length > currentIndex && isImageSlide(slides[currentIndex]));
  });
  useLayoutEffect(updateZoomSupported, [currentIndex, updateZoomSupported]);
  var context = React.useMemo(function () {
    return {
      isMinZoom: isMinZoom,
      isMaxZoom: isMaxZoom,
      isZoomSupported: isZoomSupported,
      setIsMinZoom: setIsMinZoom,
      setIsMaxZoom: setIsMaxZoom
    };
  }, [isMinZoom, isMaxZoom, isZoomSupported]);
  return React.createElement(ZoomContext.Provider, {
    value: context
  }, children);
};